import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Dialog,
  Body,
  Input,
  Dropdown,
  DropdownMenuItem,
} from "@postidigital/posti-components";
import { useTranslation } from "react-i18next";
import { showToast } from "../../../CommomFiles/globalFunctions";
import { _addCustomerData,
  _getAutoGeneratedUserId,
  _getUserGroups } from "../../../Services/masterDataServices";
import { addMDCustomerFormSchema } from "../../../CommomFiles/FormsValidationSchema";
import MasterDataAddButton from "../../../components/MasterData/MasterDataAddButton";
import { hideLoader, showLoader } from '../../../Store/Actions/commonAction';

const Status = ["Active", "Inactive"];

const AddMDCustomer = ({ close, updateList }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isStatusDropdownOpen, setStatusDropdown] = useState(false);
  const [errors, setErrors] = useState(null);
  const [product, setProduct] = useState({
    customerId: "",
    customerName: "",
    customerCode: "",
    customerStatus: "",
    streetName: "",
    streetNo: "",
    postCode: "",
    city: "",
    province: "",
    spocName: "",
    spocEmail: "",
    spocPhNo: "",
    orgCode: "o1",
    groups: []
  });

  const [isGroupDropdownOpen, setGroupDropdown] = useState(false);
  const [autoGeneratedId, setAutoGeneratedId] = useState("");
  const [userGroupOptions, setUserGroupOptions] = useState([""]);

  useEffect(() => {
    getAutoGeneratedUserId("customer");
    getUserGroup();
  }, []);

  const addCustomer = () => {
    const customer = { ...product };
    customer["customerStatus"] = product?.status;
    delete customer["status"];
    dispatch(
      _addCustomerData(
        customer,
        (res) => {
          const responseData = res.data;
          updateList(responseData[0]);
          showToast(t("CUSTOMER_ADDED_SUCCESSFULLY"), "success");
          close();
        },
        (err) => {
          console.log(err);
        }
      )
    );
  };

  const onInputChange = (val, key) => {
    const _product = { ...product };
    if (key === "groups" && !(_product[`${key}`].includes(val))) {
      _product[`${key}`].push(val)

    }
    else if (key === "groups" && (_product[`${key}`].includes(val))) {
      const index = (_product[`${key}`].indexOf(val));
      if (index > -1) { // only splice array when item is found
        (_product[`${key}`]).splice(index, 1); // 2nd parameter means remove one item only
      }
    }
    else {
      _product[`${'customerId'}`] = autoGeneratedId;
      _product[`${key}`] = val;
    }

    setProduct(_product);
    setErrors(null);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    const isFormValid = await addMDCustomerFormSchema.isValid(product, {
      abortEarly: false, // Prevent aborting validation after first error
    });

    if (isFormValid) {
      addCustomer();
    } else {
      // If form is not valid, check which fields are incorrect:
      addMDCustomerFormSchema
        .validate(product, { abortEarly: false })
        .catch((err) => {
          const errors = err.inner.reduce((acc, error) => {
            return {
              ...acc,
              [error.path]: error.message,
            };
          }, {});
          setErrors(errors);
        });
    }
  };

   //get autgenerated userId
   const getAutoGeneratedUserId = (customerId) => {
   
    _getAutoGeneratedUserId(
      { userType: customerId },
      (res) => {
        dispatch(showLoader());
        setAutoGeneratedId(res.data.cognitoId);
        const _product = { ...product };
        _product[`${'customerId'}`] = res.data.cognitoId;
        setProduct(_product);
        dispatch(hideLoader());
      },
      (err) => {
        console.log("Error=>", err)
      }
    )
  };

  //get list of groups
  const getUserGroup = (customer) => {
    dispatch(showLoader());
    _getUserGroups(
      (res) => {
        if (res.data.length > 0 && res.data !== undefined) {
          if (res.data.find(element => element.group_name === "SMS_Customer")) {
            const _product = { ...product };
            _product[`${'groups'}`].push("SMS_Customer");
            setProduct(_product);
          }
          res.data.forEach((i) => {
            setUserGroupOptions(userGroupOptions => userGroupOptions.concat(i.group_name));
          })
        }
        dispatch(hideLoader());
      },
      (err) => {
        dispatch(hideLoader());
      }
    )
  };

  return (
    <Dialog
      bottomButtons={
        <MasterDataAddButton title={"SAVE"} onClick={(e) => onSubmit(e)} />
      }
      closeText="Close dialog"
      disableOutsideClick={true}
      headerContent={t("ADD_CUSTOMER")}
      onClose={() => {
        close();
      }}
      style={{ width: "600px" }}
    >
      <Body as="div" className="customer_input_container" size="Four">
        <Input
          type="text"
          label={t("CUSTOMER_ID")}
          value={autoGeneratedId}
          onChange={(e) => onInputChange(e.target.value, "customerId")}
          required
          readOnly
          className="customer_input_control"
          message={errors && t(errors["customerId"])}
          isInvalid={errors && "customerId" in errors}
        />
        <Input
          type="text"
          label={t("CUSTOMER_NAME")}
          value={product?.customerName}
          onChange={(e) => onInputChange(e.target.value, "customerName")}
          required
          className="customer_input_control"
          message={errors && t(errors["customerName"])}
          isInvalid={errors && "customerName" in errors}
        />
        <Input
          type="text"
          label={t("CUSTOMER_CODE")}
          value={product?.customerCode}
          onChange={(e) => onInputChange(e.target.value, "customerCode")}
          required
          className="customer_input_control"
          message={errors && t(errors["customerCode"])}
          isInvalid={errors && "customerCode" in errors}
        />
        <div className="m_d_customer_dropdown_container">
          <Dropdown
            isOpen={isStatusDropdownOpen}
            title={product?.status}
            iconColor="#73808C"
            label={t("STATUS")}
            menuAriaLabel="status"
            className="m_d_customer_dropdown"
            onSelect={(e) => onInputChange(e, "status")}
            onToggle={() =>
              setStatusDropdown((isStatusDropdownOpen) => !isStatusDropdownOpen)
            }
            isValid={!(errors && "status" in errors)}
            message={errors && t(errors["status"])}
            overflowMenuContainerDirection="right"
          >
            {Status?.map((item, index) => {
              return (
                <DropdownMenuItem
                  allowWrap
                  aria-label="Menu item"
                  tabIndex={index}
                  value={item}
                  selected={product?.status === item}
                  key={item}
                  className="m_d_customer_dropdown_item"
                >
                  {item}
                </DropdownMenuItem>
              );
            })}
          </Dropdown>
        </div>
        <Input
          type="text"
          label={t("STREET_NAME")}
          value={product?.streetName}
          onChange={(e) => onInputChange(e.target.value, "streetName")}
          required
          className="customer_input_control"
          message={errors && t(errors["streetName"])}
          isInvalid={errors && "streetName" in errors}
        />
        <Input
          type="text"
          label={t("STREET_NUMBER")}
          value={product?.streetNo}
          onChange={(e) => onInputChange(e.target.value, "streetNo")}
          required
          className="customer_input_control"
          message={errors && t(errors["streetNo"])}
          isInvalid={errors && "streetNo" in errors}
        />
        <Input
          type="text"
          label={t("POST_CODE")}
          value={product?.postCode}
          onChange={(e) => onInputChange(e.target.value, "postCode")}
          required
          className="customer_input_control"
          message={errors && t(errors["postCode"])}
          isInvalid={errors && "postCode" in errors}
        />
        <Input
          type="text"
          label={t("CITY")}
          value={product?.city}
          onChange={(e) => onInputChange(e.target.value, "city")}
          required
          className="customer_input_control"
          message={errors && t(errors["city"])}
          isInvalid={errors && "city" in errors}
        />
        <Input
          type="text"
          label={t("SPOC_NAME")}
          value={product?.spocName}
          onChange={(e) => onInputChange(e.target.value, "spocName")}
          required
          className="customer_input_control"
          message={errors && t(errors["spocName"])}
          isInvalid={errors && "spocName" in errors}
        />
        <Input
          type="text"
          label={t("SPOC_EMAIL")}
          value={product?.spocEmail}
          onChange={(e) => onInputChange(e.target.value, "spocEmail")}
          required
          className="customer_input_control"
          message={errors && t(errors["spocEmail"])}
          isInvalid={errors && "spocEmail" in errors}
        />
        <Input
          type="text"
          label={t("SPOC_PHONE_NUMBER")}
          value={product?.spocPhNo}
          onChange={(e) => onInputChange(e.target.value, "spocPhNo")}
          required
          className="customer_input_control"
          message={errors && t(errors["spocPhNo"])}
          isInvalid={errors && "spocPhNo" in errors}
        />
        <div className="m_d_carrier_dropdown_container drpGroup">
          <Dropdown
            isOpen={isGroupDropdownOpen}
            title={product?.groups.toString().replace('SMS', " SMS")}
            iconColor="#73808C"
            label={t("GROUP")}
            menuAriaLabel="groups"
            className="m_d_carrier_dropdown"
            onSelect={(e) => onInputChange(e, "groups")}
            onToggle={() =>
              setGroupDropdown((isGroupDropdownOpen) => !isGroupDropdownOpen)
            }
            isValid={!(errors && "groups" in errors)}
            message={errors && t(errors["groups"])}
            overflowMenuContainerDirection="right"
            isMulti
          >
            {userGroupOptions?.map((item, index) => {
              return (
                <DropdownMenuItem
                  id={index}
                  allowWrap
                  aria-label="Menu item"
                  tabIndex={index}
                  value={item}
                  selected={product?.groups.includes(item)}
                  key={item}
                  className="m_d_carrier_dropdown_item"
                >
                  {item}
                </DropdownMenuItem>
              );
            })}
          </Dropdown>
        </div>
      </Body>
    </Dialog>
  );
};

export default AddMDCustomer;
